import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6454e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transactions-page" }
const _hoisted_2 = { class: "transactions-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "transactions-eyebrow" }, "Seus lançamentos"),
  /*#__PURE__*/_createElementVNode("h1", null, "Gastos e entradas"),
  /*#__PURE__*/_createElementVNode("p", null, "Acompanhe o que entrou e saiu sem perder nenhum detalhe.")
], -1))
const _hoisted_4 = { class: "transactions-header__actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "create-actions",
  "aria-label": "Cadastrar movimentação"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "create-action__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-arrow-up-right",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Registrar"),
  /*#__PURE__*/_createElementVNode("strong", null, "Novo gasto")
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "create-action__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-arrow-down-left",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Registrar"),
  /*#__PURE__*/_createElementVNode("strong", null, "Nova entrada")
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  class: "transactions-panel",
  "aria-labelledby": "transactions-list-title"
}
const _hoisted_14 = { class: "transactions-toolbar" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "transactions-eyebrow" }, "Movimentações", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "transactions-list-title" }, "Histórico", -1))
const _hoisted_17 = { class: "transactions-toolbar__summary" }
const _hoisted_18 = ["aria-expanded"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-sliders-horizontal",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = {
  key: 0,
  id: "transaction-filters",
  class: "filters-panel"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mês", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Todos os meses", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ano", -1))
const _hoisted_25 = { class: "filters-panel__actions" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = {
  key: 1,
  class: "transactions-feedback transactions-feedback--error",
  role: "alert"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_29 = {
  key: 2,
  class: "transaction-skeletons",
  "aria-label": "Carregando lançamentos"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--icon" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--content" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton--amount" }, null, -1))
const _hoisted_33 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "desktop-transactions-table" }
const _hoisted_35 = { class: "finance-data-table" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Descrição"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Categoria"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Origem"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Data"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, "Valor"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Ações")
    ])
  ])
], -1))
const _hoisted_37 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_38 = { class: "table-description" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "source-badge" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-trash",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "mobile-transactions-list" }
const _hoisted_48 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_49 = { class: "transaction-item__main" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "•", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "•", -1))
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "transaction-item__side" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-trash",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "pagination-row" }
const _hoisted_60 = { class: "pagination-row__summary" }
const _hoisted_61 = { class: "pagination-actions" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["aria-current", "onClick"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "pagination-mobile" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 4,
  class: "empty-transactions"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "empty-transactions__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-receipt",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nenhum lançamento neste período", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Registre um gasto ou uma entrada para começar seu histórico.", -1))
const _hoisted_76 = {
  key: 0,
  class: "transaction-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "transactionModalTitle"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "transaction-modal__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_78 = { class: "transaction-modal__header" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "transactions-eyebrow" }, "Novo lançamento", -1))
const _hoisted_80 = { id: "transactionModalTitle" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  class: "transaction-type-selector",
  "aria-label": "Tipo do lançamento"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-up-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-down-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_86 = { class: "amount-field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "R$", -1))
const _hoisted_89 = { class: "transaction-form-grid" }
const _hoisted_90 = {
  key: 0,
  class: "form-field"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Outros (automático)", -1))
const _hoisted_93 = ["value"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data e hora", -1))
const _hoisted_95 = { class: "form-field" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1))
const _hoisted_97 = { class: "recurring-check" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Este lançamento é recorrente", -1))
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}
const _hoisted_101 = {
  key: 1,
  class: "transaction-detail",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "transactionDetailTitle"
}
const _hoisted_102 = { class: "transaction-detail__content" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "transaction-detail__handle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_104 = { class: "transaction-detail__header" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "transactions-eyebrow" }, "Detalhes", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "transactionDetailTitle" }, "Lançamento", -1))
const _hoisted_107 = { class: "transaction-detail__header-actions" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-pencil-simple",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editar", -1))
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = { class: "amount-field transaction-detail__amount-field" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "R$", -1))
const _hoisted_116 = {
  key: 0,
  class: "form-field"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Outros (automático)", -1))
const _hoisted_119 = ["value"]
const _hoisted_120 = { class: "form-field" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1))
const _hoisted_122 = {
  class: "transaction-detail__grid transaction-detail__grid--metadata",
  "aria-label": "Informações não editáveis"
}
const _hoisted_123 = { "aria-disabled": "true" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Data e hora", -1))
const _hoisted_125 = { "aria-disabled": "true" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Origem", -1))
const _hoisted_127 = { class: "transaction-detail__edit-actions" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = ["disabled"]
const _hoisted_130 = {
  key: 0,
  class: "ph ph-check",
  "aria-hidden": "true"
}
const _hoisted_131 = {
  key: 1,
  class: "transactions-feedback transactions-feedback--error mb-0",
  role: "alert"
}
const _hoisted_132 = { class: "transaction-detail__grid" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Descrição", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Categoria", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Data e hora", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Origem", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "raw-message-card__heading" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "ph ph-chat-circle-dots",
      "aria-hidden": "true"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "O que foi dito à IA"),
    /*#__PURE__*/_createElementVNode("small", null, "Mensagem original do lançamento")
  ])
], -1))
const _hoisted_138 = { key: 0 }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = {
  key: 2,
  class: "transaction-detail__recurring"
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrows-clockwise",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_142 = {
  key: 2,
  class: "delete-dialog",
  role: "alertdialog",
  "aria-modal": "true",
  "aria-labelledby": "deleteDialogTitle"
}
const _hoisted_143 = { class: "delete-dialog__content" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "delete-dialog__icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-trash",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "deleteDialogTitle" }, "Remover lançamento?", -1))
const _hoisted_146 = { class: "delete-dialog__actions" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinancialPrivacyButton = _resolveComponent("FinancialPrivacyButton")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FinancialPrivacyButton),
        _createElementVNode("button", {
          class: "refresh-button",
          type: "button",
          disabled: _ctx.getLoadingFinance,
          "aria-label": "Atualizar lançamentos",
          title: "Atualizar lançamentos",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.getLoadingFinance }]),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("button", {
        class: "create-action create-action--expense",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTransactionModal('expense')))
      }, _hoisted_9),
      _createElementVNode("button", {
        class: "create-action create-action--income",
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTransactionModal('income')))
      }, _hoisted_12)
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", null, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.paginationSummary), 1)
        ]),
        _createElementVNode("button", {
          class: "filter-toggle",
          type: "button",
          "aria-expanded": _ctx.showFilters,
          "aria-controls": "transaction-filters",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
        }, [
          _hoisted_19,
          _createElementVNode("span", null, _toDisplayString(_ctx.activePeriodLabel), 1),
          _createElementVNode("i", {
            class: _normalizeClass(["ph", _ctx.showFilters ? 'ph-caret-up' : 'ph-caret-down']),
            "aria-hidden": "true"
          }, null, 2)
        ], 8, _hoisted_18)
      ]),
      (_ctx.showFilters)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("label", null, [
              _hoisted_21,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.month) = $event)),
                class: "form-select"
              }, [
                _hoisted_22,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: month.value,
                    value: month.value
                  }, _toDisplayString(month.label), 9, _hoisted_23))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.filters.month]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.year) = $event)),
                type: "number",
                min: "2000",
                max: "2100",
                class: "form-control",
                placeholder: "Ano"
              }, null, 512), [
                [_vModelText, _ctx.filters.year]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                class: "filter-reset",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
              }, "Mês atual"),
              _createElementVNode("button", {
                class: "filter-apply",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, [
                _createTextVNode(" Aplicar filtro "),
                _hoisted_26
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.getFinanceError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", null, [
              _hoisted_28,
              _createElementVNode("span", null, _toDisplayString(_ctx.getFinanceError), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
            }, "Tentar novamente")
          ]))
        : _createCommentVNode("", true),
      (_ctx.getLoadingFinance && !_ctx.getFinanceTransactions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item) => {
              return _createElementVNode("div", {
                key: item,
                class: "transaction-skeleton"
              }, _hoisted_33)
            }), 64))
          ]))
        : (_ctx.getFinanceTransactions.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("table", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinanceTransactions, (transaction) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: transaction.id,
                        class: "transaction-table-row",
                        tabindex: "0",
                        "aria-label": `Ver detalhes de ${_ctx.transactionDescription(transaction)}`,
                        onClick: ($event: any) => (_ctx.openTransactionDetails(transaction)),
                        onKeydown: _withKeys(($event: any) => (_ctx.openTransactionDetails(transaction)), ["enter"])
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["transaction-type-icon", `is-${transaction.type}`]),
                              style: _normalizeStyle(_ctx.transactionIconStyle(transaction))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(transaction.type === 'income' ? 'ph ph-arrow-down-left' : 'ph ph-arrow-up-right'),
                                "aria-hidden": "true"
                              }, null, 2)
                            ], 6),
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", {
                                title: _ctx.transactionDescription(transaction)
                              }, _toDisplayString(_ctx.transactionDescription(transaction)), 9, _hoisted_39),
                              (_ctx.$store.getters.getCouple)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString(transaction.owner?.name), 1))
                                : _createCommentVNode("", true),
                              (transaction.is_recurring)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_41, "Recorrente"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(transaction.type === 'income' ? 'Não se aplica' : (transaction.category?.name || 'Sem categoria')), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.sourceLabel(transaction.source)), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(transaction.occurred_at)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["transaction-amount text-end", `is-${transaction.type}`])
                        }, _toDisplayString(_ctx.privateValue(`${transaction.type === 'income' ? '+' : '-'}${_ctx.money(transaction.amount)}`)), 3),
                        _createElementVNode("td", _hoisted_43, [
                          (transaction.can_edit !== false)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "delete-button",
                                type: "button",
                                "aria-label": "Remover lançamento",
                                title: "Remover lançamento",
                                onClick: _withModifiers(($event: any) => (_ctx.requestDelete(transaction)), ["stop"])
                              }, _hoisted_46, 8, _hoisted_44))
                            : _createCommentVNode("", true)
                        ])
                      ], 40, _hoisted_37))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionGroups, (group) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: group.key,
                    class: "transaction-group"
                  }, [
                    _createElementVNode("h3", null, _toDisplayString(group.label), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (transaction) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: transaction.id,
                        class: "transaction-item",
                        role: "button",
                        tabindex: "0",
                        "aria-label": `Ver detalhes de ${_ctx.transactionDescription(transaction)}`,
                        onClick: ($event: any) => (_ctx.openTransactionDetails(transaction)),
                        onKeydown: _withKeys(($event: any) => (_ctx.openTransactionDetails(transaction)), ["enter"])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["transaction-type-icon", `is-${transaction.type}`]),
                          style: _normalizeStyle(_ctx.transactionIconStyle(transaction))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(transaction.type === 'income' ? 'ph ph-arrow-down-left' : 'ph ph-arrow-up-right'),
                            "aria-hidden": "true"
                          }, null, 2)
                        ], 6),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("strong", {
                            title: _ctx.transactionDescription(transaction)
                          }, _toDisplayString(_ctx.transactionDescription(transaction)), 9, _hoisted_50),
                          (_ctx.$store.getters.getCouple)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_51, _toDisplayString(transaction.owner?.name), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(transaction.type === 'income' ? 'Não se aplica' : (transaction.category?.name || 'Sem categoria')) + " ", 1),
                            _hoisted_52,
                            _createTextVNode(" " + _toDisplayString(_ctx.sourceLabel(transaction.source)) + " ", 1),
                            _hoisted_53,
                            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(transaction.occurred_at)), 1)
                          ]),
                          (transaction.is_recurring)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_54, "Recorrente"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("strong", {
                            class: _normalizeClass(["transaction-amount", `is-${transaction.type}`])
                          }, _toDisplayString(_ctx.privateValue(`${transaction.type === 'income' ? '+' : '-'}${_ctx.money(transaction.amount)}`)), 3),
                          (transaction.can_edit !== false)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "delete-button",
                                type: "button",
                                "aria-label": "Remover lançamento",
                                title: "Remover lançamento",
                                onClick: _withModifiers(($event: any) => (_ctx.requestDelete(transaction)), ["stop"])
                              }, _hoisted_58, 8, _hoisted_56))
                            : _createCommentVNode("", true)
                        ])
                      ], 40, _hoisted_48))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.paginationSummary), 1),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage <= 1,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                  }, "Anterior", 8, _hoisted_62),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationPages, (page) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: page,
                      type: "button",
                      class: _normalizeClass({ active: page === _ctx.currentPage }),
                      "aria-current": page === _ctx.currentPage ? 'page' : undefined,
                      onClick: ($event: any) => (_ctx.goToPage(page))
                    }, _toDisplayString(page), 11, _hoisted_63))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage >= _ctx.lastPage,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                  }, "Próxima", 8, _hoisted_64)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Página anterior",
                    disabled: _ctx.currentPage <= 1,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                  }, _hoisted_68, 8, _hoisted_66),
                  _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.lastPage), 1),
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Próxima página",
                    disabled: _ctx.currentPage >= _ctx.lastPage,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                  }, _hoisted_71, 8, _hoisted_69)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _hoisted_73,
              _hoisted_74,
              _hoisted_75,
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openTransactionModal('expense')))
              }, "Registrar primeiro gasto")
            ]))
    ]),
    (_ctx.showTransactionModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _createElementVNode("div", {
            class: "transaction-modal__backdrop",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionModal && _ctx.closeTransactionModal(...args)))
          }),
          _createElementVNode("form", {
            class: "transaction-modal__content",
            onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitTransaction && _ctx.submitTransaction(...args)), ["prevent"]))
          }, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", null, [
                _hoisted_79,
                _createElementVNode("h2", _hoisted_80, _toDisplayString(_ctx.modalTitle), 1)
              ]),
              _createElementVNode("button", {
                class: "transaction-modal__close",
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionModal && _ctx.closeTransactionModal(...args)))
              }, _hoisted_82)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ active: _ctx.form.type === 'expense' }),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.type = 'expense'))
              }, [
                _hoisted_84,
                _createTextVNode(" Gasto ")
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ active: _ctx.form.type === 'income' }),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.type = 'income'))
              }, [
                _hoisted_85,
                _createTextVNode(" Entrada ")
              ], 2)
            ]),
            _createElementVNode("label", _hoisted_86, [
              _hoisted_87,
              _createElementVNode("div", null, [
                _hoisted_88,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.amountInput) = $event)),
                  type: "text",
                  inputmode: "numeric",
                  autocomplete: "off",
                  placeholder: "0,00",
                  "aria-label": "Valor do lançamento",
                  required: "",
                  onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.sanitizeAmountInput && _ctx.sanitizeAmountInput(...args))),
                  onPaste: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAmountPaste && _ctx.handleAmountPaste(...args)), ["prevent"]))
                }, null, 544), [
                  [_vModelText, _ctx.amountInput]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              (_ctx.form.type === 'expense')
                ? (_openBlock(), _createElementBlock("label", _hoisted_90, [
                    _hoisted_91,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.category_id) = $event)),
                      class: "form-select"
                    }, [
                      _hoisted_92,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinanceCategories, (category) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: category.id,
                          value: category.id
                        }, _toDisplayString(category.name), 9, _hoisted_93))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.category_id]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", {
                class: _normalizeClass(["form-field", { 'form-field--wide': _ctx.form.type === 'income' }])
              }, [
                _hoisted_94,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.occurred_at) = $event)),
                  type: "datetime-local",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.form.occurred_at]
                ])
              ], 2)
            ]),
            _createElementVNode("label", _hoisted_95, [
              _hoisted_96,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.description) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Ex: mercado, aluguel, salário"
              }, null, 512), [
                [_vModelText, _ctx.form.description]
              ])
            ]),
            _createElementVNode("label", _hoisted_97, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.is_recurring) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.is_recurring]
              ]),
              _hoisted_98
            ]),
            _createElementVNode("button", {
              class: "save-transaction-button",
              type: "submit",
              disabled: _ctx.saving
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Salvando...' : _ctx.modalSubmitLabel), 1),
              (!_ctx.saving)
                ? (_openBlock(), _createElementBlock("i", _hoisted_100))
                : _createCommentVNode("", true)
            ], 8, _hoisted_99),
            (_ctx.feedback)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["transactions-feedback mt-15 mb-0", _ctx.feedbackClass])
                }, _toDisplayString(_ctx.feedback), 3))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedTransaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
          _createElementVNode("div", {
            class: "transaction-detail__backdrop",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionDetails && _ctx.closeTransactionDetails(...args)))
          }),
          _createElementVNode("section", _hoisted_102, [
            _hoisted_103,
            _createElementVNode("header", _hoisted_104, [
              _createElementVNode("div", null, [
                _hoisted_105,
                _hoisted_106,
                _createElementVNode("small", null, _toDisplayString(_ctx.selectedTransaction.owner?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_107, [
                (!_ctx.detailEditing && _ctx.selectedTransaction.can_edit !== false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "transaction-detail__edit-button",
                      type: "button",
                      title: "Editar lançamento",
                      onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.startTransactionEdit && _ctx.startTransactionEdit(...args)))
                    }, _hoisted_110))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Fechar detalhes",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closeTransactionDetails && _ctx.closeTransactionDetails(...args)))
                }, _hoisted_112)
              ])
            ]),
            (_ctx.detailEditing)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "transaction-detail__edit-form",
                  onSubmit: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveTransactionEdit && _ctx.saveTransactionEdit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", _hoisted_113, [
                    _hoisted_114,
                    _createElementVNode("div", null, [
                      _hoisted_115,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.detailAmountInput) = $event)),
                        type: "text",
                        inputmode: "numeric",
                        autocomplete: "off",
                        placeholder: "0,00",
                        "aria-label": "Valor do lançamento",
                        required: "",
                        onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.sanitizeDetailAmountInput && _ctx.sanitizeDetailAmountInput(...args))),
                        onPaste: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDetailAmountPaste && _ctx.handleDetailAmountPaste(...args)), ["prevent"]))
                      }, null, 544), [
                        [_vModelText, _ctx.detailAmountInput]
                      ])
                    ])
                  ]),
                  (_ctx.selectedTransaction.type === 'expense')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_116, [
                        _hoisted_117,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.detailForm.category_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_118,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinanceCategories, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.id
                            }, _toDisplayString(category.name), 9, _hoisted_119))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.detailForm.category_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", _hoisted_120, [
                    _hoisted_121,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.detailForm.description) = $event)),
                      class: "form-control",
                      rows: "3",
                      maxlength: "255",
                      placeholder: "Descreva este lançamento"
                    }, null, 512), [
                      [_vModelText, _ctx.detailForm.description]
                    ])
                  ]),
                  _createElementVNode("dl", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.formatDateTime(_ctx.selectedTransaction.occurred_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _hoisted_126,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.sourceLabel(_ctx.selectedTransaction.source)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _ctx.detailSaving,
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.cancelTransactionEdit && _ctx.cancelTransactionEdit(...args)))
                    }, "Cancelar", 8, _hoisted_128),
                    _createElementVNode("button", {
                      class: "is-primary",
                      type: "submit",
                      disabled: _ctx.detailSaving
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.detailSaving ? 'Salvando...' : 'Salvar alterações'), 1),
                      (!_ctx.detailSaving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_130))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_129)
                  ]),
                  (_ctx.detailFeedback)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(_ctx.detailFeedback), 1))
                    : _createCommentVNode("", true)
                ], 32))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["transaction-detail__amount", `is-${_ctx.selectedTransaction.type}`])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["transaction-type-icon", `is-${_ctx.selectedTransaction.type}`]),
                      style: _normalizeStyle(_ctx.transactionIconStyle(_ctx.selectedTransaction))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.selectedTransaction.type === 'income' ? 'ph ph-arrow-down-left' : 'ph ph-arrow-up-right'),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 6),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedTransaction.type === 'income' ? 'Entrada' : 'Gasto'), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(`${_ctx.selectedTransaction.type === 'income' ? '+' : '-'}${_ctx.money(_ctx.selectedTransaction.amount)}`)), 1)
                    ])
                  ], 2),
                  _createElementVNode("dl", _hoisted_132, [
                    _createElementVNode("div", null, [
                      _hoisted_133,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.transactionDescription(_ctx.selectedTransaction)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_134,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.selectedTransaction.type === 'income' ? 'Não se aplica' : (_ctx.selectedTransaction.category?.name || 'Sem categoria')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_135,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.formatDateTime(_ctx.selectedTransaction.occurred_at)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_136,
                      _createElementVNode("dd", null, _toDisplayString(_ctx.sourceLabel(_ctx.selectedTransaction.source)), 1)
                    ])
                  ])
                ], 64)),
            _createElementVNode("div", {
              class: _normalizeClass(["raw-message-card", { 'is-empty': !_ctx.selectedTransaction.raw_message }])
            }, [
              _hoisted_137,
              (_ctx.selectedTransaction.raw_message)
                ? (_openBlock(), _createElementBlock("blockquote", _hoisted_138, "“" + _toDisplayString(_ctx.selectedTransaction.raw_message) + "”", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_139, "Este lançamento foi registrado manualmente, sem uma mensagem original."))
            ], 2),
            (_ctx.selectedTransaction.is_recurring)
              ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                  _hoisted_141,
                  _createTextVNode(" Lançamento recorrente ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pendingDelete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
          _createElementVNode("div", {
            class: "delete-dialog__backdrop",
            onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
          }),
          _createElementVNode("div", _hoisted_143, [
            _hoisted_144,
            _hoisted_145,
            _createElementVNode("p", null, " “" + _toDisplayString(_ctx.transactionDescription(_ctx.pendingDelete)) + "” será removido do seu histórico. ", 1),
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.deleting,
                onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
              }, "Cancelar", 8, _hoisted_147),
              _createElementVNode("button", {
                class: "is-danger",
                type: "button",
                disabled: _ctx.deleting,
                onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, _toDisplayString(_ctx.deleting ? 'Removendo...' : 'Sim, remover'), 9, _hoisted_148)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}